<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <vx-card>
  <div id="data-list-list-view" class="data-list-container">

    <data-view-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData"  :dataFields="tableFormColumns" />
    <vs-progress v-if="dataLoading" indeterminate color="primary"></vs-progress>
    <vs-table ref="table" :sst="true" @search="handleSearch" @change-page="handleChangePage" @sort="handleSort" multiple v-model="selected" :max-items="itemsPerPage" search :data="tableData">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <div class="flex flex-wrap-reverse items-center data-list-btn-container">

          <!-- ACTION - DROPDOWN -->
          <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer mr-4 mb-4">

            <div class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32 w-full">
              <span class="mr-2">Actions</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Delete</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Archive</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Print</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="SaveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Another Action</span>
                </span>
              </vs-dropdown-item>

            </vs-dropdown-menu>
          </vs-dropdown>

          <!-- ADD NEW -->
          <div class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary" @click="addNewData">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Add New</span>
          </div>

        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ totalRecords - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : totalRecords }} of {{ totalRecords }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage=4">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th :sort-key="item.Field" v-for="(item, row) in tableFormColumns" :key="row">{{item.Comment==''?item.Field:item.Comment}}</vs-th>
        <vs-th>Action</vs-th>
      </template>

        <template slot-scope="{data}">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

              <vs-td v-for="(item, row) in tableFormColumns" :key="row" class="">{{ tr[item.Field] }}</vs-td>

              <vs-td class="whitespace-no-wrap">
                <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="editData(tr)" />
                <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteData(tr.id)" />
              </vs-td>

            </vs-tr>
          </tbody>
        </template>
        

    </vs-table>
      <vs-pagination
        :total="totalPages"
        :max="10"
        v-model="currentPage" />


      <vs-popup fullscreen title="fullscreen" :active.sync="popupActive">
        <div id="spreadsheet" ref="spreadsheet"></div>

      </vs-popup>

  </div>
    </vx-card>
</template>

<script>
import DataViewSidebar from '../DataViewSidebar.vue'
import moduleDataList from "@/store/data-list/moduleDataList.js"
import jexcel from 'jexcel'
import 'jexcel/dist/jexcel.css'
import PopupFullscreen from './../../../components/vuesax/popup/PopupFullscreen.vue'

export default {
  components: {
    DataViewSidebar,
    PopupFullscreen
  },
  data() {
    return {
      dataLoading: true,
      popupActive: false,
      selected: [],
      // products: [],
      itemsPerPage: 10,
      isMounted: false,

      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {},
      tableHeaders: [],
      tableColumns: [],
      tableData: [],
      totalRecords: 0,
      tableSearch: '',
      tableFormColumns: [],
      tableSortedColumn: null,
      tableSortedColumnDir: null
    }
  },
  watch: {
    async itemsPerPage(numPage) {
      let data = await this.getRecords('id', '', 1, numPage, this.tableSearch)
      this.tableData = data.records
      this.totalRecords = data.total
    },
    async $route (){
      this.tableColumns = []
      this.tableHeaders = await this.getHeaders()
      let object = this.tableHeaders
      for (const key in object) {
        if (object.hasOwnProperty(key)) {
          const element = object[key]
          this.tableColumns.push(element.Field)
        }
      }

      this.tableFormColumns = await this.filterColumns(this.$route.name, this.tableHeaders)

      await this.getRecords('id', '', 1, this.itemsPerPage).then(data => {
        this.tableData = data.records
        this.totalRecords = data.total
      })
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.totalRecords/this.itemsPerPage)
    },
    currentPage: {
      get() {
        return 1
      },
      async set(val) {
        // console.log(`The user changed the page to: ${val}, ${this.tableSortedColumn}`)
        let data = await this.getRecords(this.tableSortedColumn?this.tableSortedColumn:'id', this.tableSortedColumnDir?this.tableSortedColumnDir:'', val, this.itemsPerPage, this.tableSearch)        
        this.tableData = data.records
        this.totalRecords = data.total
      }
    },
    products() {
      return this.$store.state.dataList.products
    },
    queriedItems() {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.totalRecords
    },
    headers() {
      // console.log('TABLE HEADERS')
      return this.$store.state.dataList.headers
    },
    jExcelOptions() {
      let columns = []
      for (let i = 0; i < this.tableFormColumns.length; i++) {
        const e = this.tableFormColumns[i]
        columns.push({
          type: 'text',
          title: e.Comment,
          width: '120px'
        })
      }
      return {
        data: [[]],
        columns: columns
      }
    }
  },
  async beforeMount() {
    this.tableColumns = []
    this.tableHeaders = await this.getHeaders()
    let object = this.tableHeaders
    for (const key in object) {
      if (object.hasOwnProperty(key)) {
        const element = object[key]
        this.tableColumns.push(element.Field)
      }
    }
    this.tableFormColumns = []
    this.tableFormColumns = await this.filterColumns(this.$route.name, this.tableHeaders)
    const jExcelObj = jexcel(this.$refs["spreadsheet"], this.jExcelOptions);
    // Object.assign(this, jExcelObj); // pollutes component instance
    Object.assign(this, { jExcelObj });
  },
  methods: {
    async filterColumns(table, tableHeaders) {
      let res = []
      if ( ['Transportation', 'Cashflow'].includes(table) ) {
        // res = tableHeaders.filter(e => !['createdAt', 'updatedAt'].includes(e.Field) )
        for (let i = 0; i < tableHeaders.length; i++) {
          const e = tableHeaders[i]
          if (!['createdAt', 'updatedAt','id'].includes(e.Field)) {
            res.push(e)
          }
        }
      } else {
        res = tableHeaders
        console.log('no', tableHeaders)
      }
          console.log(table, res)
      return res
    },
    async getHeaders() {
      let data  = await this.$http.get(`https://dd.public.uz/fserver/custom/${this.$route.name}/describe`)
        .then((response) => {
          return response.data
        })
        // .catch((error) => { console.log(error) })
      return data
    },
    async getRecords(sortBy, sortDesc, page, itemsPerPage, filter) {
        this.dataLoading = true
        let where = "(id,ne,z)"
        if (filter!=undefined) {
          if (filter!='') {
            where = "(("+ this.tableColumns.join(",like,~" + filter + "~)~or(") + ",like,~" + filter + "~))" 
          }
        }
        let data = await this.$http.get(`https://dd.public.uz/fserver/getall/${this.$route.name}/`, {
            params: {
                "_size": itemsPerPage === -1 ? 1000000 : itemsPerPage,
                "_p": page,
                "_where": where,
                "_sort": (sortDesc=='desc' ? '-' : '') + (typeof sortBy === "undefined" ? 'id' : sortBy),
                "_fields": "-",
                "_tableconstruction_version": "vertri",
                "_table_name": this.$route.name
            }
        }).then(response => {
            this.dataLoading = false
            return response.data
        })

        return data
    },
    async handleSearch(searching) {
      // console.log(`The user searched for: ${searching}`)
      let data = await this.getRecords('id', '', 1, this.itemsPerPage, searching)
      this.tableData = data.records
      this.totalRecords = data.total
      this.tableSearch = searching
    },
    async handleChangePage(page) {
      let data = await this.getRecords(this.tableSortedColumn?this.tableSortedColumn:'id', this.tableSortedColumnDir?this.tableSortedColumnDir:'', page, this.itemsPerPage)
      this.tableData = data.records
      this.totalRecords = data.total
    },
    async handleSort(key, active) {
      // console.log(`the user ordered: ${key} ${active}`)
      this.tableSortedColumn = key
      this.tableSortedColumnDir = active
      let data = await this.getRecords(key, active, 1, this.itemsPerPage, this.tableSearch)
      this.tableData = data.records
      this.totalRecords = data.total
    },
    addNewData() {
      this.sidebarData = {}
      this.toggleDataSidebar(true)
    },
    deleteData(id) {
      this.$store.dispatch("dataList/removeItem", id).catch(err => { console.error(err) })
    },
    editData(data) {
      // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      this.sidebarData = data
      this.toggleDataSidebar(true)
    },
    getOrderStatusColor(status) {
      if(status == 'on_hold') return "warning"
      if(status == 'delivered') return "success"
      if(status == 'canceled') return "danger"
      return "primary"
    },
    getPopularityColor(num) {
      if(num > 90) return "success"
      if(num >70) return "primary"
      if(num >= 50) return "warning"
      if(num < 50) return "danger"
      return "primary"
    },
    toggleDataSidebar(val=false) {
      this.addNewDataSidebar = val
    }
  },
  created() {
    if(!moduleDataList.isRegistered) {
      this.$store.registerModule('dataList', moduleDataList)
      moduleDataList.isRegistered = true
    }
    this.$store.dispatch("dataList/fetchDataListItems", "Products")
    this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + this.$store.state.AppActiveUser.scjw
    // this.$store.dispatch("dataList/fetchHeaders", this.$route.name)
  },
  async mounted() {
    this.isMounted = true
    let data = await this.getRecords('id', '', 1, this.itemsPerPage)
    this.tableData = data.records
    this.totalRecords = data.total
    console.log(this.tableData, this.totalRecords)
  }
}
</script>

<style lang="scss">
#data-list-list-view {
  .vs-pagination--li {
    width: auto;
    min-width: 35px;
    border: solid 0.04rem #7367F0;
    padding-right: 0.2rem;
    padding-left: 0.2rem;
  }
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 0.5rem;
      // padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            // padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          /*td.td-check{
            padding: 20px !important;
          }*/
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
